import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { setJsonld } from '../actions/jsonld.actions';
import { JsonLdService } from '../services/json-ld.service';
import { from } from 'rxjs';

@Injectable()
export class JsonldEffects {

  constructor(
    private actions$: Actions,
    private route: ActivatedRoute,
    private jsonLdService: JsonLdService
  ) {}

  setJsonld$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setJsonld),
      switchMap(({metadataInput}) => from(this.jsonLdService.computeCreativeWorkJsonld(metadataInput)).pipe(
        map((creativeWorkJsonLd: Record<string, any>) => this.jsonLdService.setJsonLd(creativeWorkJsonLd)),
      )),
    ),
    { dispatch: false }
  );
}
